module.exports = __webpack_public_path__ + "static/media/slider-agency-website-slide-02-bg.16aada03.jpg";